import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import BodyClassName from 'react-body-classname'
import { Modal as RModal } from 'reactstrap'

/*
  Reactstrap's modal is directly adding `modal-open` to body and that is overriden
  by react-body-classname. This fixes the issue.
*/
const YModal = ({ isOpen, ...props }) => (
  <BodyClassName className={classnames({ 'modal-open': isOpen })}>
    <RModal
      isOpen={isOpen} {...props}
      // closing modal and opening new one leaves body without `modal-open`,
      // so rename it not to conflict with body-class-name
      cssModule={{ 'modal-open': '-modal-open' }}
    />
  </BodyClassName>
)

YModal.propTypes = {
  isOpen: PropTypes.bool
}

export default YModal
